import { useRef } from 'react';

export const useMemoWithEqualityCheck = <T>(value: T, isEqual: (oldValue: T, newValue: T) => boolean) => {
  const memoValRef = useRef<T>(value);
  const eq = isEqual(memoValRef.current, value);
  if (!eq) memoValRef.current = value;
  return eq ? memoValRef.current : value;
};
